import { RevelioPageId } from '../../components/PageConfigProvider/types';

/**
 * Pages that must not OFFER county at all.
 *
 * Everywhere else the picker follows the active taxonomy's levels. A page
 * whose query can't take county yet simply doesn't narrow by it, which is
 * recoverable the moment support lands. The screeners are the exception:
 * `get-screener-filters` maps geography onto company HQ selectors and handles
 * only `region` / `country` / `msa`, so a county selection there can never do
 * anything, and county support is not planned. Offering a level that is
 * permanently inert is worse than hiding it.
 */
export const COUNTY_EXCLUDED_PAGE_IDS: Set<string> = new Set([
  RevelioPageId.COMPANY_SCREENER,
  RevelioPageId.GEOGRAPHY_SCREENER,
  RevelioPageId.ROLE_SCREENER,
]);
